/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Display_Settings_Success_MessageInputs */



/**
* | output |
* | --- |
* | "Display settings updated successfully" |
*
* @param {Iframe_Remote_Display_Settings_Success_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_display_settings_success_message = /** @type {((inputs?: Iframe_Remote_Display_Settings_Success_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Display_Settings_Success_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parametres d'affichage mis a jour avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzeigeeinstellungen erfolgreich aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di visualizzazione aggiornate correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки дисплея успешно обновлены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La configuración de pantalla se actualizó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示设置已成功更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示設定が正常に更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिस्प्ले सेटिंग्स सफलतापूर्वक अपडेट हो गईं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de exibição atualizadas com sucesso")
	return /** @type {LocalizedString} */ ("Display settings updated successfully")
});